import { z } from 'zod';

export const QRURLParamsSchema = z.object({
  token: z.string().min(1, 'Missing token'),
  patientReference: z.string().optional(),
  encounterReference: z.string().optional(),
  healthRecordId: z.string().optional(),
  conditionId: z.string().optional(),
  medicalUnitId: z.string().optional(),
});

export type QRURLParams = z.infer<typeof QRURLParamsSchema>;
